/**
 * Input Number to interact with api events
 */
import React, { useCallback } from 'react';
import { InputNumber, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import _ from 'lodash';
const AsyncInputNumber = (props) => {
    const [isLoading, setIsLoading] = React.useState(false);
    const debouncedChange = useCallback(_.debounce(qty => sendChange(qty), 600), []);
    const sendChange = async (qty) => {
        setIsLoading(true);
        await props.onChange(qty);
        setIsLoading(false);
    };
    const antIcon = React.createElement(LoadingOutlined, { style: { fontSize: 10 }, spin: true });
    return (React.createElement("div", { className: "flex flex row" },
        React.createElement(InputNumber, { ...props, onChange: qty => {
                if (qty) {
                    debouncedChange(qty);
                }
            } }),
        React.createElement(Spin, { style: {
                position: 'relative',
                right: 36,
            }, spinning: isLoading, size: "small", indicator: antIcon })));
};
export default AsyncInputNumber;
